import { KeyValueMap, StringMap } from "../../../../components.props";

export interface FilterProps {
  key: string;
  value: string;
}

export interface OperationFilterButtonProps {
  show: boolean;
  filters: StringMap;
  pathFilterL: KeyValueMap;
  // Texto a mostrar para el valor de un filtro activo (p.ej. el código
  // "refund" -> "Devolución"). Sin él se muestra el valor tal cual.
  formatValue?: (key: string, value: string) => string;
  deleteByKey: DeleteByKey;
  deleteAll: () => void;
  modal: {
    content: React.ReactNode;
    textButton: string;
    onOk: () => void;
    backdropClosable?: boolean;
  };
  className?: string;
  disabled?: boolean;
}

export interface FiltersProps {
  filters: StringMap;
  pathFilterL: KeyValueMap;
  // Texto a mostrar para el valor de un filtro activo (p.ej. el código
  // "refund" -> "Devolución"). Sin él se muestra el valor tal cual.
  formatValue?: (key: string, value: string) => string;
  deleteByKey: DeleteByKey;
  deleteAll: () => void;
}

export type DeleteByKey = (key: string) => void;

export const objectToKeyValueArray = (obj: StringMap): FilterProps[] => {
  return Object.entries(obj)
    .filter(([_, value]) => value.trim() !== "")
    .map(([key, value]) => ({ key, value }));
};
